<template>
  <div class="section-banner">
    <!-- <el-carousel :height="height" :interval="4000" type="card"> -->
    <!-- :autoplay="false" -->
    <el-carousel
      :height="height"
      :autoplay="false"
      @change="handleCarouselChange"
      ref="carousel"
      indicator-position="none"> 
      <!-- <el-carousel :height="height" direction="vertical"> -->
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <div
          class="banner"
          :style="{
            background: 'url(' + item.img + ')',
          }">
          <router-link :to="item.link || '#'">
            <div style="width: 100%; height: 450px; display: block"></div>
          </router-link>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- <div class="custom-indicators">
      <span
        v-for="(item, index) in items"
        :key="index"
        @click="handleCarouselChange(index)"
        :class="{ active: index === currentIndex }"
        :style="{
          background: 'url(' + item.image + ')',
        }"></span>
    </div> -->
    <!-- <el-carousel :height="height">
            <el-carousel-item v-for="(v,k) in list" :key="k">
                <div class="banner" :style="'background-position: center;background-image:url('+v.url+');'"><router-link :to="v.link||'#'"><div style="width:1200px;height:450px;display:block;"></div></router-link></div>
            </el-carousel-item>
        </el-carousel> -->
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
    },
    height: {
      type: String,
      default: "600px",
    },
  },
  data() {
    return {
      // url: "@/static/img/ad/ad1.png",
      url: "@/static/img/ad/gongsijianjie.png",
      // 轮播项配置数组：在数据定义时就执行 require，确保 webpack 能识别打包
      bannerList: [
        { img: require('@/static/img/ad/gongsijianjie.png'), link: "/about" },
        { img: require('@/static/img/ad/MAE.png'), link: "/product/detail/1110426" },
        { img: require('@/static/img/ad/MFC8600.png'), link: "/product/detail/1110430" },
        { img: require('@/static/img/ad/MFC8800.png'), link: "/product/detail/1110432" },
        { img: require('@/static/img/ad/CRD520.webp'), link: "/product/detail/1110398" },
        { img: require('@/static/img/ad/CGD_T-6000.png'), link: "/product/detail/1110401" },
        { img: require('@/static/img/ad/RGD-9001.webp'), link: "/product/detail/1110404" },
        { img: require('@/static/img/ad/pH_ORP_D_T-7000.webp'), link: "/product/detail/1110407" },
        { img: require('@/static/img/ad/DOD_T-5000.webp'), link: "/product/detail/1110408" },
        { img: require('@/static/img/ad/pHD_T-5000.webp'), link: "/product/detail/1110405" },
      ],
      default_list: [
        { url: "@/static/img/ad/gongsijianjie.png", link: "/product/detail/1110082" },
        { url: "@/static/img/ad/MAE.png", link: "/product/detail/1110082" },
        { url: "@/static/img/ad/MFC8600.png", link: "/product/detail/1110027" },
        { url: "@/static/img/ad/MFC8800.png", link: "/product/detail/1110043" },
        { url: "@/static/img/ad/CRD520.webp", link: "/product/detail/1110398" },
        { url: "@/static/img/ad/CGD_T-6000.png", link: "/product/detail/1110401" },
        { url: "@/static/img/ad/RGD-9001.webp", link: "/product/detail/1110404" },
        { url: "@/static/img/ad/pH_ORP_D_T-7000.webp", link: "/product/detail/1110407" },
        { url: "@/static/img/ad/DOD_T-5000.webp", link: "/product/detail/1110408" },
        { url: "@/static/img/ad/pHD_T-5000.webp", link: "/product/detail/1110405" },
      ],
      items: [
        { name: "Slide 1", image: require('@/static/img/ad/gongsijianjie.png') },
        { name: "Slide 2", image: require('@/static/img/ad/MAE.png') },
        { name: "Slide 3", image: require('@/static/img/ad/MFC8600.png') },
        { name: "Slide 4", image: require('@/static/img/ad/MFC8800.png') },
        { name: "Slide 5", image: require('@/static/img/ad/CRD520.webp') },
        { name: "Slide 6", image: require('@/static/img/ad/CGD_T-6000.png') },
        { name: "Slide 7", image: require('@/static/img/ad/RGD-9001.webp') },
        { name: "Slide 8", image: require('@/static/img/ad/pH_ORP_D_T-7000.webp') },
        { name: "Slide 9", image: require('@/static/img/ad/DOD_T-5000.webp') },
        { name: "Slide 10", image: require('@/static/img/ad/pHD_T-5000.webp') },
      ],
      currentIndex: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleCarouselChange(index) {
      this.currentIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
/deep/ .container {
  margin: 20px auto 140px auto !important;
}
.section-banner {
  // margin-top: 30px;
}
/* 自定义指示器样式（同上） */
.custom-indicators {
  z-index: 5;
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
}

.custom-indicators span {
  width: 160px;
  height: 100px;
  margin: 0 20px;
  border-radius: 4%;
  cursor: pointer;
  background-size: contain !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-color: rgba(255, 255, 255, 0) !important;
}

.custom-indicators span.active {
  transform: scale(1.3);
  background-color: rgba(255, 255, 255, 0.4) !important;
}

/deep/ .banner {
  height: 100%;
  cursor: pointer;
  perspective: 3000px;
  position: relative;
  z-index: 99;
  margin: 0 auto;
  width: 80%;
  background-size: contain !important;
  background-position: center !important;
  background-repeat: no-repeat !important;

  border-radius: 10px;
}
/deep/ .el-carousel__item--card.is-active {
  background-color: rgb(35, 50, 128) !important;
  border: 1px solid #ccc;
}
// /deep/ .el-carousel__arrow--left {
//   left: 10%;
// }
// /deep/ .el-carousel__arrow--right {
//   right: 10%;
// }
</style>
